import { useState, useEffect, useRef, useMemo } from "react";
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import ReactDatePicker from "react-datepicker";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet-async";
import moment from "moment";
import SearchBar from "@components/searchBar/SearchBar";
import { baseImgUrl } from "@api/client/api";
import { onLoading } from "@store/slices/loaderSlice";
import { TbCurrentLocation, IoLocationOutline, FiPlus, FiMinus, IoMdClose } from '@assets/Icons';
import ImagesData from "@assets/ImagesData";
import { getNextDay, isJsonString, applyTax } from "@utils/utils";
import services from '@api/services';
import { propertyPolicy } from "@constant/constants";
import CommonSlider from "@shared/slick/CommonSlider";
import SklHotelDetail from "@shared/skeleton/SklHotelDetail";
import { MdOutlineCalendarMonth } from "react-icons/md";

const accordions = [
    {
        title: "Why should we book rooms with RRooms",
        content: "RRooms services are a must to avail for everyone out there looking for hotels because - We offer a vast array of hotels and accommodations, providing you with an extensive selection of options to choose from. We have exclusive deals and discounts, helping you secure the best possible rates for your room. Once you've chosen your ideal room, you can complete the booking process within the app very smoothly. A powerful price comparison option that allows you to compare rates from various booking platforms and hotels directly."
    },
    {
        title: "Benefits of RRooms for frequent travelers",
        content: "RRooms provides special loyalty points, exclusive discounts, and faster booking options for frequent travelers. You can save more and access premium hotels easily with just a few clicks."
    },
    {
        title: "RRooms partnered hotels are safe?",
        content: "RRooms provides special loyalty points, exclusive discounts, and faster booking options for frequent travelers. You can save more and access premium hotels easily with just a few clicks."
    },
    {
        title: "Are unmarried couples allowed to check-in?",
        content: "RRooms provides special loyalty points, exclusive discounts, and faster booking options for frequent travelers. You can save more and access premium hotels easily with just a few clicks."
    }
];

const HotelDetails = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const selectRoomRef = useRef(null);
    const toDateRef = useRef(null);
    const wrapper = useRef();
    const slotRef = useRef(null);
    const fullSlotRef = useRef(null);
    const headerRef = useRef(null);
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    const baseURL = window.location.origin;
    const [propertyData, setPropertyData] = useState({});
    const [amenitiesData, setAmenitiesData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [cancelShare, setShowShare] = useState(false);
    const [fromdate, setFromDate] = useState(new Date());
    const [todate, setToDate] = useState(getNextDay());
    const [slotDate, setSlotDate] = useState(new Date())
    const [OurRooms, setOurRooms] = useState([]);
    const [showImagesModal, setShowImagesModal] = useState(false);
    const [showMore, setShowMore] = useState(-1);
    const [openIndex, setOpenIndex] = useState(-1);
    const [showPolicy, setShowPolicy] = useState([]);
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [slider1, setSlider1] = useState(null);
    const [slider2, setSlider2] = useState(null);
    const [onTopShow, setTopShow] = useState(false);
    const [firstTime, setFirstTime] = useState(false);
    const [mapHotelName, setMapHOtelName] = useState('');
    const [newPrice, setNewPrice] = useState('');
    const [nearestProperty, setNearestProperty] = useState([]);
    const [slot, setSlot] = useState('');
    const [saveCheckinTime, setSaveCheckinTime] = useState({});
    const [dateRange, setDateRange] = useState([today, tomorrow]);
    const [startDate, endDate] = dateRange;

    // const hotelId = path?.split("-")?.pop()?.match(/\d+$/)?.[0];
    let hotelId = location?.pathname?.split("-").pop()?.match(/\d+$/)?.[0];
    const hotelPolicy = Array.isArray(showPolicy)
    // const isBookHotel = location.pathname.includes("book-hotel");    

    useEffect(() => { setPropertyData({}) }, [location])

    useEffect(() => {
        const savedSlot = localStorage.getItem("slot");
        if (savedSlot) setSlot(savedSlot);
    }, []);

    useEffect(() => {
        if (slot == "hourly" && slotRef.current) { slotRef.current.scrollIntoView({ behavior: "smooth", block: "start" }); }
        if (slot == "fullDay" && fullSlotRef.current) { fullSlotRef.current.scrollIntoView({ behavior: "smooth", block: "start" }); }
    }, [fullSlotRef.current, slotRef.current, slot]);

    useEffect(() => { window.scrollTo(0, 0) }, [location])

    const toggleAccordion = (index) => { setOpenIndex(openIndex == index ? -1 : index) };

    const getPropertyDetail = async (id) => {
        dispatch(onLoading(true))
        try {
            const res = await services.property.getSinglePropertyService(id);
            if (res.status == 200) {
                let data = res?.data?.data;
                setPropertyData(data);
                setFirstTime(true);
                let policy = [data.bookingPolicy];
                if (isJsonString(data.bookingPolicy)) { policy = JSON.parse(data.bookingPolicy) }
                const cleanedArray = policy.filter(item => item.trim() != "");
                setShowPolicy(cleanedArray);
            }
        } catch (error) { console.log("Error in getPropertyDetail function") }
        finally { dispatch(onLoading(false)) }
    };

    const getAmenities = async () => {
        try {
            const res = await services.property.getAmenitiesService();
            if (res.status == 200) { setAmenitiesData(res?.data?.data); }
        } catch (error) { console.log("Error in getAmenities function") }
    };

    const getRoomCategory = async () => {
        try {
            const res = await services.property.getRoomCategoryService();
            if (res.status == 200) { setCategoryData(res?.data?.data) }
        } catch (error) { console.log("Error in getRoomCategory function") }
    };

    const fetchNearestProperty = async () => {
        try {
            const res = await services.property.getNearestProperty(hotelId)
            if (res.status == 200 && res.data.status == true) { setNearestProperty(res?.data?.data) }
        }
        catch { console.log("Error in fetchNearestProperty function") }
    }

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "hotel_details" });
        if (hotelId) {
            getAmenities();
            getPropertyDetail(hotelId);
            getRoomCategory();
            fetchNearestProperty()
        }
    }, [navigate]);

    const getReview = async (id) => {
        try {
            const res = await services.globalService.getCustomerReviewPropertyIdService(id);
            if (res.status == 200) { setTableData(res?.data?.data) }
        } catch (error) { console.log("Error in getReview function") }
    };

    useEffect(() => { if (propertyData?.id) { getReview(propertyData.id) } }, [propertyData]);

    const amenitiesRender = (dataType, dataset) => {
        let selectedAminits = [];
        if (dataType == "property") {
            amenitiesData.map((data) => {
                propertyData.PropertyAmenities.filter((innerData) => { if (innerData.propertyAmenitiesId == data.id) { selectedAminits.push(data) } });
            });
        } else {
            amenitiesData.map((data) => { dataset.filter((innerData) => { if (innerData.amenitiesId == data.id) { selectedAminits.push(data) } }); });
        }
        return selectedAminits;
    };

    let uniqueImages = propertyData?.PropertyImage?.filter((item, ind, self) => {
        return ind == self?.findIndex((data) => data?.id == item?.id)
    })

    const profileImg = propertyData?.PropertyImage?.length ? propertyData?.PropertyImage.find((i) => i.id == propertyData?.profileImageID) : null;

    const imageList = propertyData?.PropertyImage || [];

    if (profileImg) { imageList.unshift(profileImg); }

    const pet = propertyData?.travellerChoice ? propertyData?.travellerChoice.split(',').find((anm) => anm == 15) : []
    const PayAtHotel = propertyData?.travellerChoice ? propertyData?.travellerChoice.split(',').find((anm) => anm == 16) : []

    const dateFilter = async () => {
        const fd = fromdate ? `&fromDate=${fromdate?.toISOString().substring(0, 10)} 00:00:00` : "";
        const td = todate ? `&toDate=${todate?.toISOString().substring(0, 10)} 00:00:00` : "";
        try {
            const res = await services.property.getRroomsPropertyByFilter(`/${hotelId}?${fd}${td}`);
            setOurRooms(res.data.data.Rooms);
        } catch (error) { console.log("Error in dateFilter function") }
    };

    useMemo(() => { if (firstTime) dateFilter(); }, [fromdate, todate]);

    const setShowMoreFun = (index) => {
        if (index == showMore) { setShowMore(-1) }
        else { setShowMore(index); }
    };

    useEffect(() => {
        window.addEventListener("scroll", () => {
            let el = selectRoomRef.current;
            var _x = 0;
            var _y = 0;
            while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
                _x += el.offsetLeft - el.scrollLeft;
                _y += el.offsetTop - el.scrollTop;
                el = el.offsetParent;
            }
            const scrollTop = window.scrollY;
            if (_y < scrollTop) { setTopShow(true); }
            else { setTopShow(false); }
        });
    }, []);

    const bookHandler = (data, slot, priceLast) => {
        const dataSet = categoryData?.find((innerData) => { if (innerData?.id == data?.categoryId) { return innerData?.name } });
        const hotelData = {
            ...data,
            categoryName: dataSet?.name,
            propertyName: propertyData?.name,
            address: propertyData?.address,
            city: propertyData?.city,
            landmark: propertyData?.landmark,
            partialPayment: propertyData?.partialPayment,
            slot,
            priceLast,
        };
        localStorage.setItem('hotelData', JSON.stringify(hotelData));
        localStorage.setItem('categoryData', JSON.stringify(categoryData));
        navigate(`/book-hotel/${data?.id}`);
    };

    const bindHotelNameAndLocation = () => { if (propertyData?.name) { const hotelMapLocation = propertyData?.name; setMapHOtelName(hotelMapLocation) } }

    useEffect(() => { bindHotelNameAndLocation() }, [propertyData])

    function safeParse(value, fallback = []) {
        if (value == null) return fallback;
        if (Array.isArray(value)) return value;
        if (typeof value == "string") {
            if (value.trim() == "") return fallback;
            try {
                const parsed = JSON.parse(value);
                return Array.isArray(parsed) ? parsed : fallback;
            } catch { return fallback; }
        }
        return fallback;
    }

    function getBookingRange(startTime, bookingSlot) {
        const hours = parseInt(bookingSlot, 10);
        const [h, m] = startTime.split(":").map(Number);
        const start = new Date();
        start.setHours(h);
        start.setMinutes(m);
        const end = new Date(start.getTime() + hours * 60 * 60 * 1000);
        const pad = (n) => String(n).padStart(2, "0");
        const endStr = `${pad(end.getHours())}:${pad(end.getMinutes())}`;
        return `${startTime} to ${endStr}`;
    }

    function getHoursArray(checkIn, checkOut) {
        const startTime = checkIn && checkIn.trim() != '' ? checkIn : '00:00';
        const endTime = checkOut && checkOut.trim() != '' ? checkOut : '23:00';
        const start = parseInt(startTime.split(':')[0], 10);
        const end = parseInt(endTime.split(':')[0], 10);
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();
        let minStart = start;
        const todayStr = moment().format("YYYY-MM-DD");
        if (checkToday == todayStr) {
            const nextHour = currentMinute > 0 ? currentHour + 1 : currentHour;
            if (nextHour > minStart) { minStart = nextHour }
        }
        const hours = [];
        for (let h = minStart; h <= end; h++) { hours.push(`${h.toString().padStart(2, '0')}:00`) }
        return hours;
    }

    const mergeAllSlotsForDate = (statusData, priceData, date, slotRegularPrices, timePeriods, fullDayStatusData) => {
        const statusSlots = statusData?.[date] || [];
        const priceSlots = priceData?.[date] || [];
        const timeSlots = timePeriods?.[date] || [];
        const fullDayStatus = fullDayStatusData?.[date] || []
        return ALL_SLOTS.map(slot => {
            const statusItem = statusSlots.find(s => s.slot == slot);
            const priceItem = priceSlots.find(p => p.slot == slot);
            const timeItem = timeSlots.find(t => t.slot == slot);
            const fullDayStatusItem = fullDayStatus.find(t => t.slot == slot);
            let fallbackPrice = null;
            switch (slot) {
                case "3Hrs":
                    fallbackPrice = slotRegularPrices?.threeHrPrice;
                    break;
                case "6Hrs":
                    fallbackPrice = slotRegularPrices?.sixHrPrice;
                    break;
                case "9Hrs":
                    fallbackPrice = slotRegularPrices?.nineHrPrice;
                    break;
                case "FullDay":
                    fallbackPrice = slotRegularPrices?.regularPrice;
                    break;
            }
            return {
                slot,
                status: statusItem ? statusItem.status : "Available",
                price: Number(priceItem?.price || fallbackPrice),
                checkIn: timeItem?.checkIn || null,
                checkOut: timeItem?.checkOut || null
            };
        });
    };

    const ALL_SLOTS = ["3Hrs", "6Hrs", "9Hrs", "FullDay", "FullDayStatus"];
    const [checkToday, setCheckToday] = useState(moment().format('YYYY-MM-DD'))

    let room = propertyData?.Rooms?.find(r => r?.categoryId == 1);

    let threeHrStatus = safeParse(room?.threeHrStatus, {});
    let threeHrOfferPrice = safeParse(room?.threeHrOfferPrice, {});
    let slotRegularPrices = room;
    let timePeriods = safeParse(room?.threeHrCheckIn, {});
    let fullDayStatusData = safeParse(room?.status, []);

    const newData = { [checkToday]: mergeAllSlotsForDate(threeHrStatus, threeHrOfferPrice, checkToday, slotRegularPrices, timePeriods, fullDayStatusData) };

    const [selectedRoomCate, setSelectedRoomCate] = useState('')
    const [selectedCheckinTime, setSelectedCheckinTime] = useState('')
    const [selectedTimes, setSelectedTimes] = useState({});
    const [roomAvilablty, setRoomAvilablty] = useState({})

    const handleCheckRoomAvilablty = async (value, slot, idx, checkInTime, checkOutTime) => {
        setSaveCheckinTime({ checkInTime: checkInTime, checkOutTime: checkOutTime })
        setSelectedCheckinTime(value)
        let payload = {
            propertyId: propertyData?.id,
            propertyRoomsCategoryId: 1,
            date: checkToday,
            bookingType: slot,
            startTime: value,
            duration: slot?.slice(0, 2)
        }
        setSelectedTimes(prev => ({ ...prev, [idx]: value }));
        setSelectedRoomCate(value)
        const res = await services.property.checkRoomAvilabltyService(payload)
        if (res.data.status == true) { setRoomAvilablty(res?.data?.data) }
    }

    const createBooking = (i, slot, priceLast, checkInTime, checkOutTime) => {
        if (!selectedTimes[i]) {
            toast.error("Please select check-in Time.");
            return;
        }
        let roomData = propertyData?.Rooms.find((item) => item.categoryId == 1)
        const hotelData = {
            ...roomData,
            categoryName: 'STANDARD DOUBLE BED',
            propertyName: propertyData?.name,
            address: propertyData?.address,
            city: propertyData?.city,
            landmark: propertyData?.landmark,
            partialPayment: propertyData?.partialPayment,
            slot,
            priceLast,
            bookingSlot: slot?.slice(0, 3),
            bookingType: 'Hourly',
            bookingHours: getBookingRange(selectedTimes[i], slot),
            selectedCheckinTime: selectedCheckinTime,
            avilableRoomCount: roomAvilablty?.availableRooms
        };
        localStorage.setItem('hotelData', JSON.stringify(hotelData))
        localStorage.setItem('categoryData', JSON.stringify(categoryData))
        navigate(`/book-hotel/${roomData.id}`);
    };

    const handleDailyBooking = async (e, data, slot, priceLast) => {
        e.preventDefault();
        try {
            let payload = {
                propertyId: propertyData?.id,
                propertyRoomsCategoryId: data.categoryId,
                date: checkToday,
                bookingType: 'Daily',
            }
            const res = await services.property.checkRoomAvilabltyService(payload)
            if (res.data.status == true) { setRoomAvilablty(res?.data?.data); }
            bookHandler(data, slot, priceLast);
        }
        catch { console.log("Error in handleDailyBooking") }
    }

    const listItems = document.querySelectorAll("#nav-list li");

    listItems.forEach(li => {
        li.addEventListener("click", (e) => {
            listItems.forEach(item => item.classList.remove("active"));
            li.classList.add("active");
            const targetId = li.getAttribute("data-target");
            const targetSection = document.getElementById(targetId);
            if (targetSection) {
                const offset = 64;
                const topPos = targetSection.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top: topPos, behavior: "smooth" });
            }
        });
    });

    const [selectedImg, setSelectedImg] = useState('')

    useEffect(() => {
        const isSticky = (e) => {
            const scrollTop = window.scrollY;
            scrollTop >= 250 ? headerRef?.current?.classList?.add('fixed') : headerRef?.current?.classList?.remove('fixed');
        };
        window.addEventListener('scroll', isSticky);
        return () => { window.removeEventListener('scroll', isSticky) };
    }, []);

    const [availRooms, setAvailRooms] = useState([])
    const checkFullDayRoomAvaility = async (sDate = startDate, eDate = endDate) => {
        const payload = {
            propertyId: propertyData?.id,
            propertyRoomsCategoryId: propertyData?.Rooms?.map((item) => item?.categoryId),
            fromDate: moment(sDate).format("YYYY-MM-DD"),
            toDate: moment(eDate).format("YYYY-MM-DD")
        }
        const res = await services.property.checkFullDayAvilabltyService(payload)
        if (res.status == 200) { setAvailRooms(res?.data?.data) }
    }

    useEffect(() => { if (Object.keys(propertyData).length > 0) { checkFullDayRoomAvaility() } }, [propertyData])

    return (
        <>
            <Helmet>
                <title> {propertyData?.metaTitle ? `${propertyData.metaTitle} | Best Hotel in ${propertyData?.city?.[0]?.name || ""}` : "Best Hourly Hotels | RROOMS"}</title>
                <meta name="description" content={propertyData?.metaDescription ? propertyData.metaDescription.slice(0, 160) : "Book best hotels with hourly & full day stays at RROOMS"} />
                <meta name="keywords" content={`${propertyData?.keyword || "hotel"}, hourly hotel, full day hotel, best hourly hotels, hotel booking`} />
                <meta property="og:title" content={propertyData?.metaTitle ? `${propertyData.metaTitle} | Best Hotel in ${propertyData?.city?.[0]?.name || ""}` : "Best Hourly Hotels | RROOMS"} />
                <meta property="og:description" content={propertyData?.metaDescription || "Hotel booking made easy"} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${baseURL}/best-hourly-hotel${propertyData?.slug}`} />
                <link rel="canonical" href={`${baseURL}/best-hourly-hotel${propertyData?.slug}`} />
            </Helmet>
            <div className='inner-searchBar bg-gray section-sm'><div className='container'><SearchBar /></div></div>
            {Object.keys(propertyData).length == 0 ? (<div className="section-sm"><div className="container"><SklHotelDetail /></div></div>
            ) : (<div className="section-sm hotel-details" id="overview">
                <div className="container">
                    <div className="pb-4">
                        <h2>{propertyData?.name}</h2>
                        <p className='v-center text-secondary fs-6 pt-1'>
                            <IoLocationOutline size={18} className='mr-1' />
                            {propertyData?.address}
                        </p>
                    </div>
                    <div className="primary-panel hotel-info">
                        <div className="hotel-detail-images">
                            <div className="row">
                                <div className="col-lg-7">
                                    <div className="left">
                                        <CommonSlider settings={{ slidesToShow: 1, arrows: true }}>
                                            {imageList?.map((img, index) => (
                                                <div key={index}>
                                                    <img src={img.image != "" ? `${baseImgUrl}${img.image}` : ''} className="rounded-1" alt={`Best Hourly Hotels | ${propertyData?.name} | ${propertyData?.locality}`} />
                                                </div>
                                            ))}
                                        </CommonSlider>
                                    </div>
                                </div>
                                <div className="col-lg-5 pl-0">
                                    <div className="right">
                                        {uniqueImages?.slice(0, 4)?.map((item, ind) => {
                                            return (
                                                <div className="img" key={ind} onClick={() => { ind == 3 && setShowImagesModal(true) }} style={{ cursor: ind == 3 && "pointer" }}>
                                                    <img src={item.image ? `${baseImgUrl}${item.image}` : ''} className="rounded-1 d-block" alt={`Best Hourly Hotels | ${propertyData?.name} | ${propertyData?.locality}`} />
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tabs">
                            <ul className="tab-nav" id="nav-list" ref={headerRef}>
                                <li data-target="overview" className="active">Overview</li>
                                <li data-target="amenities">Amenities</li>
                                {propertyData?.allowHourly == 1 ? <li data-target="hourly">Hourly</li> : null}
                                <li data-target="rooms">Rooms</li>
                                <li data-target="location">Location</li>
                                <li data-target="faq">FAQ’s</li>
                                <li data-target="faq">Policies</li>
                            </ul>
                            <div className="tab-content">
                                <div className="tab-box">
                                    <h3 className="pb-2">Hotel Overview</h3>
                                    <p className="fs-5">{propertyData.propertyDescription}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="hotel-amenities primary-panel" id="amenities">
                        <h3 className="pb-2">Amenities</h3>
                        <ul className="d-flex">
                            {
                                propertyData?.PropertyAmenities ?
                                    amenitiesRender("property").map((item, key) => {
                                        return (
                                            <li className="v-center" key={key}>
                                                <span><img src={baseImgUrl + item.icon} title={`Best Hourly Hotels | ${propertyData?.name} | ${propertyData?.locality}`} alt={`Best Hourly Hotels | ${propertyData?.name} | ${propertyData?.locality}`} /></span>
                                                {item?.name}
                                            </li>
                                        )
                                    }) : null
                            }
                        </ul>
                    </div>
                    {propertyData?.allowHourly ? (
                        <div className="primary-panel short-stay" ref={slotRef} id="hourly">
                            <div className="row justify-content-between">
                                <div className="col-lg-4 col-md-12">
                                    <h3>Hourly Rate Plans</h3>
                                    <p>Select your hourly stay option</p>
                                </div>
                                <div className="col-lg-3 col-md-12">
                                    <div className="flex align-items-center justify-content-end">
                                        <span className="fw-bold text-secondary white-space-nowrap mr-2">Stay Date</span>
                                        <div className="custom-react-date-picker">
                                            <ReactDatePicker
                                                id="slotDate"
                                                className="input-box"
                                                onChange={(date) => setCheckToday(moment(date).format('YYYY-MM-DD'))}
                                                selected={checkToday}
                                                minDate={new Date()}
                                                dateFormat="dd/MM/yyyy"
                                            />
                                            <MdOutlineCalendarMonth className="icon" size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-lg-6">
                                    <div className="col-img">
                                        <img src={`${baseImgUrl}${imageList?.find((item) => item.title == "Facade")?.image}`} alt={`Best Hourly Hotels | ${propertyData?.name} | ${propertyData?.locality}`} />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    {newData[checkToday]?.slice(0, 3)?.map((item, i) => {
                                        let full_day = item?.slot == "FullDay" ? "Full Day" : `${item?.slot} Slot`
                                        return (
                                            <div className="slot" key={i}>
                                                <div className="flex justify-content-between">
                                                    <div className="left">
                                                        {item?.price > 0 &&
                                                            <h4 className="text-secondary">
                                                                ₹{item?.price}
                                                                <span className="text-line-through text-light fw-normal fs-6 ml-2">₹ {applyTax(item?.price)}</span>
                                                            </h4>
                                                        }
                                                        {item?.price == 0 && <h4 className="text-light fs-6">Not Available</h4>}
                                                        <span className="text-light fs-7">Excl. Taxes</span>
                                                    </div>
                                                    <div className="right">
                                                        <h5>{full_day}</h5>
                                                        <span className="fs-7" style={{ color: '#3f8cff' }}>Flexible Check-in</span>
                                                    </div>
                                                </div>
                                                <div className="row justify-content-between pt-3">
                                                    <div className="col-lg-4">
                                                        <select
                                                            className="form-control"
                                                            disabled={item?.status == "Sold-Out" || getHoursArray(item?.checkIn, item?.checkOut)?.length == 0 || item?.price == 0 || fullDayStatusData?.find((item) => item.date == checkToday)}
                                                            value={selectedTimes[i] || ""}
                                                            onChange={(e) => handleCheckRoomAvilablty(e.target.value, item?.slot, i, item?.checkIn, item?.checkOut)}>
                                                            <option value="">Check-In Time</option>
                                                            {getHoursArray(item?.checkIn, item?.checkOut).map((item) => {
                                                                return (<option key={item}>{item}</option>)
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-block"
                                                            disabled={
                                                                item?.status == "Sold-Out" ||
                                                                fullDayStatusData?.find((item) => item?.date == checkToday) ||
                                                                (roomAvilablty?.availableRooms == 0 &&
                                                                    roomAvilablty?.bookingType == item?.slot) ||
                                                                getHoursArray(item?.checkIn, item?.checkOut)?.length == 0 || item?.price == 0
                                                            }
                                                            onClick={() => createBooking(i, item?.slot, item?.price, item?.checkIn, item?.checkOut)}>
                                                            Book Now
                                                        </button>
                                                    </div>
                                                </div>
                                                {item?.status == "Sold-Out" || getHoursArray(item?.checkIn, item?.checkOut)?.length == 0 ?
                                                    <div className="mt-2">
                                                        <p className="text-danger">Room unavailable. Change slot or check-in time.</p>
                                                    </div> : null}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    ) : null}
                    <div className="primary-panel rooms-section" id="rooms" ref={fullSlotRef}>
                        <div className="row align-items-center justify-content-between">
                            <div className="col-lg-4">
                                <h3>Full Day Rate Plan</h3>
                                <p>Select your full day stay option</p>
                            </div>
                            <div className="col-lg-3">
                                <div className="custom-react-date-picker full">
                                    <ReactDatePicker
                                        id="slotDate"
                                        className="input-box"
                                        selectsRange={true}
                                        startDate={startDate}
                                        endDate={endDate}
                                        minDate={new Date()}
                                        dateFormat="dd/MM/yyyy"
                                        onChange={(update) => {
                                            setDateRange(update);
                                            if (update[0] && update[1]) {
                                                checkFullDayRoomAvaility(moment(update[0]).format("YYYY-MM-DD"), moment(update[1]).format("YYYY-MM-DD"))
                                            }
                                        }}
                                        placeholderText="Select date range"
                                    />
                                    <MdOutlineCalendarMonth className="icon" size={20} />
                                </div>
                            </div>
                        </div>
                        <div className="room-cards mt-4">
                            <div className="row">
                                {
                                    propertyData?.Rooms?.length > 0 ? (
                                        (OurRooms?.length > 0 ? OurRooms : propertyData.Rooms).map((data, ind1) => {
                                            const roomFrom = new Date(data.fromDate);
                                            const roomTo = new Date(data.toDate);
                                            const selectedFrom = new Date(fromdate);
                                            const selectedTo = new Date(todate);
                                            const isSameDay = roomFrom.toDateString() == selectedFrom.toDateString();
                                            const isWithinRange = selectedFrom <= roomTo && selectedTo >= roomFrom;
                                            const applyOffer = isSameDay || isWithinRange;
                                            const parsedOffer = typeof data?.offerPrice == "string" ? JSON.parse(data.offerPrice) : data?.offerPrice || {};
                                            const xPrice = +(parsedOffer?.[checkToday]?.find((item) => item?.slot == "FullDay")?.price ?? 0);
                                            const finalPrice = xPrice ? xPrice : data?.regularPrice;
                                            const isFullDayBlocked = safeParse(data?.fullDayStatus)?.[checkToday]?.find(item => item?.slot == "FullDay") || null;
                                            const checkStatus = data?.status ? safeParse(data?.status || [])?.find(item => item?.date == moment(startDate).format("YYYY-MM-DD")) : {};
                                            let notAvail = availRooms?.find((item) => item?.propertyRoomsCategoryId == data?.categoryId)?.availableRooms

                                            return (
                                                <div className="col-lg-6" key={ind1}>
                                                    <div className="room-card" style={{ opacity: propertyData?.status != 1 ? 0.4 : 1 }}>
                                                        <Link href="/book-hotel" className="img">
                                                            {
                                                                data?.RoomImages.length ? (
                                                                    <CommonSlider settings={{ slidesToShow: 1, arrows: false }}>
                                                                        {
                                                                            data?.RoomImages.map((innerData, key) => {
                                                                                return (
                                                                                    <div key={key}>
                                                                                        <img
                                                                                            src={`${baseImgUrl}${innerData.imageName}`}
                                                                                            className="d-block rounded-1" title={`Best Hourly Hotels | ${propertyData?.name} | ${propertyData?.locality}`} alt={`Best Hourly Hotels | ${propertyData?.name} | ${propertyData?.locality}`}
                                                                                        />
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </CommonSlider>
                                                                ) : (<img alt="sliderImg2" src={ImagesData?.NoImage?.src} />)
                                                            }
                                                        </Link>
                                                        <div className="text">
                                                            {
                                                                categoryData?.map((innerData, key1) => {
                                                                    if (innerData.id == data.categoryId) {
                                                                        return <h4 className="pb-0" key={key1}>{innerData.name}</h4>;
                                                                    }
                                                                })
                                                            }
                                                            {data?.avaiableRooms > 0 ? null : (
                                                                <div className="soldOut">
                                                                    {data?.status ? null : (
                                                                        <img src={ImagesData?.ImgSoldout?.src} alt="sold out img" />
                                                                    )}
                                                                </div>
                                                            )}
                                                            <div className="border-bottom mt-1 mb-2"></div>
                                                            <ul className="d-flex feature text-gray">
                                                                {
                                                                    data?.RoomAmenities ?
                                                                        amenitiesRender("room", showMore === ind1 ? data?.RoomAmenities : data?.RoomAmenities?.slice(0, 3)).map((data, key3) => (
                                                                            <li className="v-center fs-7 mr-2" key={key3}>
                                                                                <span><img src={`${baseImgUrl}${data?.icon}`} title={`Best Hourly Hotels | ${propertyData?.name} | ${propertyData?.locality}`} alt={`Best Hourly Hotels | ${propertyData?.name} | ${propertyData?.locality}`} /></span>
                                                                                {data?.name}
                                                                            </li>
                                                                        )) : null
                                                                }
                                                            </ul>
                                                            <div className="mt-1 mb-2">
                                                                <h4 className="text-secondary ">
                                                                    ₹{finalPrice}
                                                                    <span className="fs-7 text-danger text-line-through ph-2">
                                                                        ₹ {Math.round(applyTax(finalPrice))}
                                                                    </span>
                                                                    <span className="text-success">20% OFF</span>
                                                                    <span className="fs-6 fw-normal text-light ml-1">per night</span>
                                                                </h4>
                                                            </div>
                                                            <div className="button">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-sm btn-block"
                                                                    onClick={(e) => handleDailyBooking(e, data, 24, finalPrice)}
                                                                    disabled={notAvail == 0 || (propertyData?.status != 1) || (isFullDayBlocked?.status == "Sold-Out") || checkStatus?.soldOut == true}
                                                                >
                                                                    Book Now
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    ) : 'Rooms Not Available!'
                                }
                            </div>
                        </div>
                    </div>
                    <div className="primary-panel location-section" id="location">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <h3>Explore the Area</h3>
                                <p className='v-center text-secondary fs-6 pt-1'>
                                    <IoLocationOutline size={18} className='mr-1' />
                                    {propertyData?.address}
                                </p>
                            </div>
                            <div className="col-lg-6 text-right">
                                <a
                                    href={`https://www.google.com/maps/search/?api=1&query=${propertyData.latitude},${propertyData.longitude}`} className="btn-mat btn-mat-secondary"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <TbCurrentLocation size={18} className="mr-1" />
                                    View on google map
                                </a>
                            </div>
                        </div>
                        <div className="map border mt-3">
                            <iframe
                                src={`https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2116.0067224963614!2d${propertyData.longitude}!3d${propertyData.latitude}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDUyJzU0LjUiTiA8MMKwNTgnNDAuNSJF!5e0!3m2!1sen!2sin!4v1693811926541!5m2!1sen!2sin`}
                                allowFullScreen
                                loading="lazy"
                                className="w-100 d-block border-0"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                    <div className="row" id="faq">
                        <div className="col-lg-6">
                            <div className="primary-panel">
                                <h3 className="pb-3">Hotel Policies</h3>
                                <div className="bg-white rounded-1 gradient-border p-3">
                                    <ul className="list">
                                        {
                                            hotelPolicy && Array.isArray(showPolicy) && (
                                                showPolicy.map((policyIndex, i) => {
                                                    const text = propertyPolicy[policyIndex]
                                                    return (<li key={i}>{text}</li>);
                                                })
                                            )
                                        }
                                    </ul>
                                    <h5 className="pv-3">Restrictions</h5>
                                    <ul className="list">
                                        <li>Guests can check in using any one of the following original ID proofs - Passport, Adhaar Card, Driving Licence, Voter ID</li>
                                        <li>Softcopy of ID proofs not accepted.</li>
                                    </ul>
                                    <h5 className="pv-3">Hotel Cancellation Policy</h5>
                                    <ul className="list">
                                        <li>Refund will be provided only if cancellation is done 24 hours prior to selected check-in time.</li>
                                        <li>In case booking has been done within 24 hours of check-in time, the refund will be provided only if the booking is cancelled within 15 minutes from the time of booking.</li>
                                        <li>There will be no refund, If you do not show up at the hotel.</li>
                                        <li>There will be no refund if you decide to cancel the booking in the middle of your stay.</li>
                                        <li>If eligible, refund will be initiated, which will reflect in your account within 5-7 business days.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="primary-panel">
                                <h3 className="pb-3">Frequesntly Asked Questions</h3>
                                <div className="bg-white rounded-1 gradient-border p-3">
                                    <div className="hotel-accordian">
                                        {accordions.map((item, index) => (
                                            <div key={index} className="border-bottom last-item-border-0 pt-2 pb-2">
                                                <div
                                                    className="head flex justify-content-between align-items-center pv-2 px-3 cursor-pointer"
                                                    onClick={() => toggleAccordion(index)}
                                                >
                                                    <h5 className="m-0 text-lg font-medium">{item.title}</h5>
                                                    <span className="text-secondary">{openIndex == index ? <FiMinus /> : <FiPlus />}</span>
                                                </div>
                                                {openIndex == index && (
                                                    <div className="body pv-2 px-3 bg-white">
                                                        <p className="fs-6 text-gray-700">{item.content}</p>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)}
            <div className="nearest-section">
                <div className="container">
                    <div className="primary-panel">
                        <h3 className="pb-3">Popular Nearby</h3>
                        <CommonSlider settings={{ slidesToShow: 4, arrows: true }}>
                            {nearestProperty?.map((item) => {
                                const img = item?.PropertyImages[0]?.image
                                const primaryImg = item?.PropertyImages?.find((data) => data?.id == item?.profileImageID)?.image
                                const city = item?.slug?.startsWith("/Lucknow")
                                const today = moment();
                                let xPrice = []
                                let mPrice = 0
                                item?.Rooms?.forEach((item) => {
                                    const fromDate = moment(item?.fromDate);
                                    const toDate = moment(item?.toDate);
                                    const isTodayInRange = today.isSameOrAfter(fromDate, "day") && today.isSameOrBefore(toDate, "day");
                                    xPrice.push(isTodayInRange ? item?.regularPrice : item?.regularPrice);
                                    mPrice = Math.min(...xPrice);
                                });
                                return (
                                    <div className="column">
                                        <div className="img">
                                            {/* <Link to={city ? `/hotels-in-lucknow${item?.slug}` : `${baseURL}/best-hourly-hotel${item?.slug}`}> */}
                                            <Link to={`${baseURL}/best-hourly-hotel${item?.slug}`}>
                                                <img src={primaryImg ? `${baseImgUrl}${primaryImg}` : `${baseImgUrl}${img}`} alt={`Best hourly hotels | ${item?.locality} | ${propertyData?.city?.[0]?.name || ""}`} />
                                            </Link>
                                            {item?.allowHourly == 1 && <span>Hourly</span>}
                                        </div>
                                        <div className="text">
                                            {/* <Link to={city ? `/hotels-in-lucknow${item?.slug}` : `/hotel-details${item?.slug}`}> */}
                                            <Link to={`${baseURL}/best-hourly-hotel${item?.slug}`}>
                                                <h3 className="fs-6 text-black mb-1">{item?.name?.slice(0, 30)}</h3>
                                            </Link>
                                            <p className="fs-8 text-light mb-1">{item?.locality}</p>
                                            <div className="flex align-items-center justify-content-between pb-2 mt-2 mb-2">
                                                {
                                                    <span className="btn-mat btn-mat-default rounded-1">
                                                        {item?.locaidAccept == 1 ? "Local ID Accepted" : "Local ID not Accepted"}
                                                    </span>
                                                }
                                                {item?.coupleFriendly == 1 && (
                                                    <span className="btn-mat btn-mat-default rounded-1">
                                                        <i className="bi bi-hearts"></i> Couple
                                                        Friendly
                                                    </span>
                                                )}
                                            </div>
                                            <div className="flex justify-content-between align-items-center border-top pt-2">
                                                <div className="price-section">
                                                    <span className="text-dark  fw-bold">₹ {mPrice}</span>
                                                    <span className="text-danger fs-8 text-decoration-line-through pl-1 pr-1">₹{Math.round(((mPrice ?? 0) * 20 / 100) + mPrice)}</span><span className="fs-8 text-success fw-bold">20% OFF</span>
                                                </div>
                                                <Link to={`${baseURL}/best-hourly-hotel${item?.slug}`} className="btn btn-secondary btn-sm">
                                                    View Detail
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </CommonSlider>
                    </div>
                </div>
            </div>
            {showImagesModal && <div className="popup-property-images">
                <div className="content">
                    <span className="close all-center" onClick={() => setShowImagesModal(false)}><IoMdClose size={18} /></span>
                    <div className="img-big" onClick={() => setSelectedImg('')}>
                        <CommonSlider settings={{ slidesToShow: 1, arrows: true }} asNavFor={nav2} ref={(slider) => setSlider1(slider)}>
                            {uniqueImages?.map((item, ind) => {
                                return (
                                    <figure className="sliderImg" key={ind}>
                                        <img src={selectedImg ? selectedImg : item.image != "" ? baseImgUrl + item.image : ''} title={`Best hourly hotels | ${propertyData?.locality} | ${propertyData?.city?.[0]?.name}`} alt={`Best hourly hotels | ${propertyData?.locality} | ${propertyData?.city?.[0]?.name}`} />
                                    </figure>
                                );
                            })}
                        </CommonSlider>
                    </div>
                    <div className="img-small">
                        <CommonSlider settings={{ slidesToShow: 5, arrows: true }} asNavFor={nav1} ref={(slider) => setSlider2(slider)}>
                            {uniqueImages?.map((img, index) => (
                                <div key={index}>
                                    <figure className="sliderImg_tab">
                                        <img src={img.image != "" ? `${baseImgUrl}${img.image}` : ''} onClick={() => setSelectedImg(`${baseImgUrl}${img.image}`)} title={`Best hourly hotels | ${propertyData?.locality} | ${propertyData?.city?.[0]?.name}`} alt={`Best hourly hotels | ${propertyData?.locality} | ${propertyData?.city?.[0]?.name}`} />
                                    </figure>
                                </div>
                            ))}
                        </CommonSlider>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default HotelDetails